import { useState } from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Route, Routes } from "react-router-dom"

import PublicIssueForm from "./PublicIssueForm"
import MaintenancePage from "@/components/MaintenancePage"

/** Public intake never mounts Clerk, tenant providers, or authenticated query state. */
export default function PublicIssueApp() {
  const [client] = useState(() => new QueryClient())
  if (import.meta.env.VITE_MAINTENANCE_MODE === "true") return <MaintenancePage />
  return (
    <QueryClientProvider client={client}>
      <Routes>
        <Route path="/public/issues/:organizationId/:formId/:linkId" element={<PublicIssueForm />} />
        <Route path="*" element={<main className="p-8">Form unavailable</main>} />
      </Routes>
    </QueryClientProvider>
  )
}
